import React, { useState } from 'react';
import { TextField, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import {
    BackgroundContainer,
    LoginContainer,
    PaperContainer,
    LogoContainer,
    LoginHeader,
    ErrorText,
    FormContainer,
    SubmitButton,
    ForgotPasswordText,
} from './LoginPage.styles';
import { useAuth } from '../../contexts/AuthContext';
import { PERMISSION_ROUTES } from '../../utils/navigation';

function LoginPage() {
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();

    const redirectTo = location.state?.redirectTo || null;
    const openCart = location.state?.openCart || false;

    const handleLogin = async (event) => {
        event.preventDefault();
        setError('');
        try {
            const data = await login(loginEmail, loginPassword);

            if (redirectTo) {
                navigate(redirectTo, { state: { openCart } });
            } else if (data.is_admin || (data.user?.roles || []).includes('admin')) {
                navigate('/product-management');
            } else if ((data.user?.roles || []).length > 0) {
                const perms = data.user?.permissions || [];
                const firstRoute = PERMISSION_ROUTES.find(r => perms.includes(r.permission));
                navigate(firstRoute ? firstRoute.path : '/order-management');
            } else {
                navigate('/user-portal');
            }
        } catch (err) {
            setError(err?.response?.data?.message || err?.response?.data?.detail || err.message || 'Login failed');
        }
    };

    return (
        <>
            <TopNavbar />
            <BackgroundContainer>
                <LoginContainer>
                    <PaperContainer elevation={3}>
                        <LogoContainer>
                            <img src="/APD_Login.png" alt="Login Logo" />
                        </LogoContainer>

                        <LoginHeader variant="h5" component="h1">
                            Login
                        </LoginHeader>

                        {error && <ErrorText>{error}</ErrorText>}

                        <FormContainer component="form" onSubmit={handleLogin}>
                            <TextField
                                required
                                fullWidth
                                id="loginEmail"
                                label="Email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                autoFocus
                                value={loginEmail}
                                onChange={(e) => setLoginEmail(e.target.value)}
                            />
                            <TextField
                                required
                                fullWidth
                                id="loginPassword"
                                label="Password"
                                type="password"
                                autoComplete="current-password"
                                value={loginPassword}
                                onChange={(e) => setLoginPassword(e.target.value)}
                            />
                            <SubmitButton type="submit" fullWidth variant="contained">
                                Login
                            </SubmitButton>
                            <ForgotPasswordText variant="body2">
                                <Link
                                    href="/forgot-password"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    Forgot password?
                                </Link>
                            </ForgotPasswordText>
                        </FormContainer>
                    </PaperContainer>
                </LoginContainer>
            </BackgroundContainer>
        </>
    );
}

export default LoginPage;
